import {getSchoolCount, hasFiles} from "../../utils/uploads";
import {MESSAGES} from "../../constants";
import UseTooltip from "../common/useTooltip";

const SchoolList = (props) => {
  const {
    schools,
    selectedSchool,
    onClick
  } = props;

  const schoolRows = (status) => {
    const schoolStatuses = schools[status];

    if (status !== 'Uploaded' && !hasFiles(schoolStatuses)) {
      return '';
    }

    function isActive(school) {
      return (school === selectedSchool);
    }

    return schoolStatuses.map((school, index) => {

      return <div className='school' key={`row-${index}`}>
        <button className={`school-list-school${isActive(school.school) ? ' school-active' : ''}`} onClick={(e) => {onClick(school, school.files)}}>{school.school}</button>
      </div>
    });
  }

  return (
    <div className='schools-list'>
      <div className='file-status-header'>
        Pending data <UseTooltip title={MESSAGES.TOOLTIPS.MY_DATA.pending} id='pending-data-tooltip'/> <span className='school-count'>{schools['Uploaded'].length}</span>
      </div>
      <div className='file-status-schools'>
        {schoolRows('Uploaded')}
      </div>
      <div className='file-status-schools'>
        {schoolRows('Verification')}
      </div>
      <div className='file-status-header'>
        Has preliminary reports <UseTooltip title={MESSAGES.TOOLTIPS.MY_DATA.preliminary} id='preliminary-reports-tooltip'/> <span className='school-count'>{getSchoolCount(schools['Preliminary'])}</span>
      </div>
      <div className='file-status-schools'>
        {schoolRows('Preliminary')}
      </div>
      <div className='file-status-header'>
        Has final reports <UseTooltip title={MESSAGES.TOOLTIPS.MY_DATA.final} id='final-reports-tooltip'/> <span className='school-count'>{getSchoolCount(schools['Final'])}</span>
      </div>
      <div className='file-status-schools'>
        {schoolRows('Final')}
      </div>
    </div>
  );
}

export default SchoolList;